'use client';
import { useEffect, useState } from 'react';
import {
  ARTICLES_LIST_HEROBANNER_QUERY,
  PAGE_HEROBANNER_QUERY,
  PRODUCTS_LIST_HEROBANNER_QUERY,
} from '@workspace/sanity-base/queries/heroBanner';
import { HeroBannerData } from '../interfaces';
import { client } from '@/sanity/lib/client';
import { namespaceType } from '@workspace/sanity-base/lib/namespace';

export const usePageHeroBanner = (pageType: string, slug?: string, isSkip?: boolean, parentSlug?: string) => {
  const [heroBannerData, setHeroBannerData] = useState<HeroBannerData | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isSkip) return;
    const fetchPageHeroBanner = async () => {
      try {
        setLoading(true);

        let pageData;
        if (pageType === 'articlesList') {
          pageData = await client.fetch(ARTICLES_LIST_HEROBANNER_QUERY, {
            pageType: namespaceType(pageType),
            slug,
          });
        } else if (pageType === 'productsList' && slug) {
          const query = parentSlug ? PRODUCTS_LIST_HEROBANNER_QUERY : PAGE_HEROBANNER_QUERY;
          const params = parentSlug
            ? { pageType: namespaceType(pageType), slug, parentSlug }
            : { pageType: namespaceType(pageType), slug };
          pageData = await client.fetch(query, params);
        }
        if (pageData?.heroBanner) {
          setHeroBannerData(pageData.heroBanner);
        } else {
          setHeroBannerData(undefined);
        }
        return;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch hero banner data');
      } finally {
        setLoading(false);
      }
    };

    fetchPageHeroBanner();
  }, [isSkip, pageType, parentSlug, slug]);

  return { heroBannerData, loading, error };
};
